// extracted by mini-css-extract-plugin
export default {"container":"_2rTifU","contentWrapper":"_2zGugj","content":"_1D5bvh"};